/**
 * Runs every step even when earlier ones throw, then reports the collected failures once.
 * For cleanup/notification fan-out where one bad participant must not starve the rest.
 */
export function runIsolated(steps: Iterable<() => void>, message: string): void {
	const errors: unknown[] = [];

	for (const step of steps) {
		try {
			step();
		}
		catch (error) {
			errors.push(error);
		}
	}

	if (errors.length > 0) console.error(message, new AggregateError(errors, message));
}
